import React, { FC, useContext } from 'react'
import { ResponsiveContainer, PieChart, Pie, Legend, Cell, Tooltip } from 'recharts'
import Title from '../Title'

import { Box } from '@mui/material'
import { ANDROID_COLOR, GRAY, IOS_COLOR } from '../../utils/colors'
import { DataContext } from '../../contexts/DataProvider'

const COLORS = [IOS_COLOR, ANDROID_COLOR, GRAY]

const CircullarChart: FC = () => {
  const { activeContract } = useContext(DataContext)

  if (!activeContract) {
    return <Title>No active contract</Title>
  }

  console.log(activeContract)
  const deviceData = activeContract.usersDevices.filter((data) => data?.deviceContext)
  const undefinedDevices = activeContract.usersDevices.filter((data) => data?.deviceContext === undefined)
  const iosDevices = deviceData.filter((device) => device.deviceContext?.platform === 'iOS')
  const androidDevices = deviceData.filter((device) => device.deviceContext?.platform === 'Android')
  const ios = {
    name: 'iOS',
    value: iosDevices.length,
  }
  const android = {
    name: 'Android',
    value: androidDevices.length,
  }
  const undefinedDevicesData = {
    name: 'No information',
    value: undefinedDevices.length,
  }
  const result = [ios, android, undefinedDevicesData]

  return (
    <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {iosDevices.length + androidDevices.length + undefinedDevices.length > 0 ? (
        <ResponsiveContainer>
          <PieChart width={730} height={250}>
            <Pie data={result} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={60} outerRadius={80} label>
              {result.map((entry, id) => (
                <Cell key={`cell=${id}`} fill={COLORS[id % COLORS.length]} />
              ))}
            </Pie>
            <Legend verticalAlign="top" height={36} />
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      ) : (
        <Title>Contract has no users</Title>
      )}
    </Box>
  )
}
export default CircullarChart
